import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { Condition } from '../../../../../types/entity.types';

import { ARCHIVED, UPCOMING } from '../../../../../utils/constants';
import { getClassNames } from '../../../../../utils/util';

import Button from '../../../../common/button/Button';

import { ReactComponent as DeleteIcon } from '../../../../../resources/icons/close.svg';

import '../accountability.scss';
import './accountability-condition.scss';

type Props = {
  status: string;
  conditions: Condition[];
  createCondition: () => void;
  updateCondition: (externalReference: string, key: keyof Condition, value: string) => void;
  deleteCondition: (externalReference: string) => void;
};

const AccountabilityCondition = ({
  status,
  conditions = [],
  createCondition,
  updateCondition,
  deleteCondition
}: Props) => {
  const [open, setOpen] = useState(true);

  const copyOfConditions = [...conditions];
  const columns: Condition[][] = [];

  let rowCount = 10;

  if (copyOfConditions.length >= 20) {
    rowCount = Math.round(copyOfConditions.length / 2);

    if (copyOfConditions.length % 2 === 0) {
      rowCount += 1;
    }
  }

  while (copyOfConditions.length) {
    const column: Condition[] = copyOfConditions.splice(0, rowCount);
    columns.push(column);
  }

  return (
    <div
      className={getClassNames('accountability__section', {
        closed: !open
      })}
      data-testid="accountability-condition"
    >
      <div className="accountability__section__header">
        <p>CONDITION</p>
        {!open && (
          <FontAwesomeIcon
            className="accountability__section__open-icon"
            icon={faPlus}
            onClick={() => setOpen(true)}
            data-testid="open-icon"
          />
        )}
        {open && (
          <FontAwesomeIcon
            className="accountability__section__close-icon"
            icon={faMinus}
            onClick={() => setOpen(false)}
            data-testid="close-icon"
          />
        )}
      </div>
      {open && (
        <div className="accountability-condition">
          {columns.map((column, index) => {
            return (
              <div className="accountability-condition__column" key={`column-${index}`} data-testid="condition-column">
                {column.map((condition, index) => {
                  return (
                    <div
                      className="accountability-condition__condition-container"
                      key={`condition-${index}`}
                      data-testid="condition-row"
                    >
                      <input
                        className="accountability-condition__condition"
                        value={condition.optionOne}
                        onChange={({ target }) =>
                          updateCondition(condition.externalReference, 'optionOne', target.value)
                        }
                        disabled={status === ARCHIVED}
                      />
                      <input
                        className="accountability-condition__condition"
                        value={condition.optionTwo}
                        onChange={({ target }) =>
                          updateCondition(condition.externalReference, 'optionTwo', target.value)
                        }
                        disabled={status === ARCHIVED}
                      />
                      {status === UPCOMING && (
                        <DeleteIcon
                          className="accountability-condition__delete-icon"
                          onClick={() => deleteCondition(condition.externalReference)}
                          data-testid="delete-icon"
                        />
                      )}
                    </div>
                  );
                })}
                {index === columns.length - 1 && conditions.length !== 10 && status !== ARCHIVED && (
                  <Button text="Add" onClick={createCondition} />
                )}
              </div>
            );
          })}
          {(conditions.length === 0 || conditions.length === 10) && (
            <div className="accountability-condition__column" data-testid="condition-column">
              {status !== ARCHIVED && <Button text="Add" onClick={createCondition} />}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AccountabilityCondition;
